__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-benefits-view-all'].baseUrl;
import ModuleContainer from './Benefitsviewall';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/browser-performance-mark': '^3.0.0',
      '@americanexpress/data-manager-utils': '^0.4.2',
      '@americanexpress/product-ducks': '^1.3.3',
      '@americanexpress/one-app-module-wrapper': '^3.4.5',
      '@americanexpress/react-ddl': '^0.1.4',
      '@americanexpress/reactlytics': '^1.2.8',
      'iguazu': '^3.1.0',
      'iguazu-holocron': '^1.1.0',
      'iguazu-rest': '^1.10.0',
      'iguazu-rpc': '^1.6.1'
    }
  });
}